import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'direction-horizontal',
  'IconDirectionHorizontal',
  [
    ['path', { d: 'M10 9l-3 3l3 3', key: 'svg-0' }],
    ['path', { d: 'M14 9l3 3l-3 3', key: 'svg-1' }],
  ],
);
